module.exports = __webpack_public_path__ + "img/success-fratelli.142270e.png";